export default "__VITE_ASSET__fFzCvL54__"